import base from '../base.js';
import BaseDevice from '../base.js'
export default class DeviceImage extends BaseDevice {

   static render = (device, scale = 1) => {
      return this.getDevice(device, scale, false, true, true);
   }

   static getTextPadding = (device, DEFAULT_PADDING) => {
      return DEFAULT_PADDING
   }

   static getHeight = (device) => {
      return 94;
   }

   static getRect(width, height) {
      return `<rect opacity="0.8" stroke="#212121" x="1.518" y="1.52" width="${width ? width - 3 : 0}" height="${height ? height / 2
         - 3 : 0}" stroke-width="3" rx="6" ry="6" style="display:inline"/>`
   }

   static getPortY = (device, position, screwWidth, height) => {
      return this.getScrewsPaddingY();
   }

   static getScrewsPaddingY = () => {
      return 40;
   }

   static getDefaultPortsCount = (width, baseWidth) => {
      return Math.ceil((width - 45) / SIZE.pxInMm / baseWidth)
   }

   static getPorts(device, position) {


      if (position !== 'top') {
         return; // we need to render just for one position
      }

      const height = this.getHeight(device);
      // const width = this.getWidth(device);
      // const baseWidth = STORAGE.getSetting('baseWidth', BASE_WIDTH)
      const ports = MODAL_CONNECTOR.getPortsCount(device.width);

      const screwWidth = 25;
      const spaceX = this.getSpaceX(screwWidth);
      const y = this.getPortY(device, position, screwWidth, height) - 6;
      let res = '';
      const initSPace = 22;
      let transform, text = ''


      ////////// TODO deleteme in August 2024 /////////////////
      // if (!device.phasesDetails) {
      //    device.phasesDetails = MODAL_CONNECTOR.generatePhasesDetails(device.phases, ports);
      // }
      ////////// END OF TODO deleteme in August 2024 /////////////////

      for (var i = 0; i < ports; i++) {
         let x = initSPace + i * screwWidth + 2 * spaceX * i;

         const textX = x + 11;
         const textY = y - 10 + (device.twisted ? -4 : 0);
         let num = i;

         if (device.twisted) {
            transform = `transform="rotate(-180, ${textX}, ${textY})"`
            num = ports - i - 1;
            text = device.phasesDetails[ports - i - 1].text;
         } else {

           
            text = ""
            device.phasesDetails && device.phasesDetails[i] && (text = device.phasesDetails[i].text)
            // device.phasesDetails.length > 0 && (text = device.phasesDetails[i].text);
            // text = device.phasesDetails[i].text;
         }

         if (device.phasesDetails && device.phasesDetails[num] && device.phasesDetails[num].display) {
            res += `<image width="${screwWidth}" height="60"  x="${x}" y="${y}" data-id="${this.getPortId(device, position, num)}" class="connector" href="${PARTS.connector}" fill="rgba(0, 168, 240, 1)"/>`
         }
         const display = device.phasesDetails ? device.phasesDetails[i].display : true;
         res += `<text data-i=${num} data-text="${text}" data-display=${display} x="${textX}" y="${textY}" class="txtBold${device.id} conText" dominant-baseline="middle" stroke='${this.isBlack(device) ? 'white' : 'black'}' text-anchor="middle" ${transform}>${text}</text>`;
      }

      res += `<style>
      .txtBold${device.id} {
         font: bold 18px sans-serif;
         fill: ${this.isBlack(device) ? "white" : "black"};
      }
    </style>`
      return res;
   }

   static getSpaceX = (screwWidth) => {
      const baseWidth = STORAGE.getSetting('baseWidth', BASE_WIDTH)
      return baseWidth * 2 - 14.45;
   }
}
